import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoSimIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_sim"}/>
}
